@if (false) {
<div class="container py-4">
  <div class="d-flex">
    <div class="w-60">
      <h4 class="text-center fw-bold mb-4">BUSINESS EXPENSE PIE CHART</h4>

      <!-- Top Summary -->
      <div class="row text-center mb-4 bg-light rounded p-3">
        <div class="col"><strong>GROSS</strong><br><span class="text-success">3,459,402.45</span></div>
        <div class="col"><strong>PREVIOUS MONTH</strong><br><span class="text-danger">3,459,402.45</span></div>
        <div class="col"><strong>CURRENT MONTH</strong><br><span class="text-success">59,402.45</span></div>
        <div class="col"><strong>CURRENCY</strong><br>AED</div>
        <div class="col"><strong>VIEW</strong><br>PREVIOUS MONTH</div>
      </div>

      <div class="">
        <ngx-charts-pie-chart [view]="[400, 400]" [results]="pieData" [legend]="false" [doughnut]="true" [labels]="true"
          [explodeSlices]="false" [gradient]="false" [animations]="true">
        </ngx-charts-pie-chart>
        <div class="text-center mt-2 fw-bold">PREVIOUS MONTH - <span class="text-danger">-12000 AED</span></div>
        <div class="text-center">
          <button class="btn btn-outline-primary btn-sm mt-3">GENERATE NEW</button>
        </div>
      </div>
    </div>
    <div ngi class="w-40">

      <!-- Charts Row -->
      <div class="row mb-4">


        <div class="col-md-6">
          <div class="bg-light rounded p-3">
            <h5 class="text-center fw-bold">INSIGHTS</h5>
            <div class="row text-center mt-3">
              <div class="col"><strong>AWS</strong><br>3,459,402.45</div>
              <div class="col"><strong>SALARIES</strong><br>3,459,402.45</div>
              <div class="col"><strong>UTILITIES</strong><br><span class="text-success">59,402.45</span></div>
              <div class="col"><strong>MARKETING</strong><br>0</div>
            </div>
            <div class="row text-center mt-3">
              <div class="col"><strong>RENT</strong><br>1000</div>
              <div class="col"><strong>EXTRAS</strong><br><span class="text-warning">3,459,402.45</span></div>
              <div class="col"><strong>CURRENCY</strong><br>AED</div>
              <div class="col"><strong>VIEW</strong><br>GROSS</div>
            </div>
          </div>
        </div>
      </div>

      <!-- History -->
      <div class="bg-light rounded p-3 mb-4 text-center">
        <h5 class="fw-bold">HISTORY</h5>
        <div class="row mt-2">
          <div class="col"><strong>AWS</strong><br><a href="#">VIEW</a></div>
          <div class="col"><strong>SALARIES</strong><br><a href="#">VIEW</a></div>
          <div class="col"><strong>UTILITIES</strong><br><a href="#" class="text-success">VIEW</a></div>
          <div class="col"><strong>MARKETING</strong><br><a href="#">VIEW</a></div>
        </div>
      </div>

      <!-- Bar Chart -->
      <div class="bg-light rounded p-3">
        <h5 class="text-center fw-bold">MINI DASHBOARD</h5>
        <ngx-charts-bar-vertical [results]="barData" [xAxis]="true" [yAxis]="true" [legend]="false"
          [showDataLabel]="true" [scheme]="'vivid'">
        </ngx-charts-bar-vertical>
      </div>
    </div>
  </div>


</div>
}
<div class="layout-container">
  <app-menu (menuToggled)="onMenuToggled($event)" />
  <app-loader *ngIf="loader" title="Loading" message="Bringing the purple vibes…" variant="dots" size="md">
  </app-loader>
  <div class="content-area" [class.menu-collapsed]="menuCollapsed()">
    @if (!editExpense || true) {
    <div *ngIf="false" class="dashboard-container">
      <div class="left-container">
        <h4 class="text-center fw-bold mb-4">BUSINESS EXPENSE PIE CHART</h4>
        <div class=" text-center business-data mb-4 bg-light rounded p-3">
          <div class="b-data">
            <p>GROSS</p><span class="text-success">3,459,402.45</span>
          </div>
          <div class="b-data">
            <p>PREVIOUS MONTH</p><span class="text-danger">3,459,402.45</span>
          </div>
          <div class="b-data">
            <p>CURRENT MONTH</p><span class="text-success">59,402.45</span>
          </div>
          <div class="b-data">
            <p>CURRENCY</p>AED
          </div>
          <div class="b-data">
            <p>VIEW</p>PREVIOUS MONTH
          </div>
        </div>
      </div>
      <div class="right-container">
        <div class="px-3 pb-4 mb-3 insights-container">
          <h5 class="text-center  fw-bold">INSIGHTS</h5>
          <div class="bg-light w-100  rounded py-3">
            <div class=" insights w-100 text-center mt-3">
              <div class="insights-data">
                <p>AWS</p>3,459,402.45
              </div>
              <div class="insights-data">
                <p>SALARIES</p>3,459,402.45
              </div>
              <div class="insights-data">
                <p>UTILITIES</p><span class="text-success">59,402.45</span>
              </div>
              <div class="insights-data">
                <p>MARKETING</p>0
              </div>
              <div class="insights-data">
                <p>RENT</p>1000
              </div>
              <div class="insights-data">
                <p>EXTRAS</p><span class="text-warning">3,459,402.45</span>
              </div>
              <div class="insights-data">
                <p>CURRENCY</p>AED
              </div>
              <div class="insights-data">
                <p>VIEW</p>GROSS
              </div>
            </div>
          </div>
        </div>
        <div class="px-3 pb-4 mb-3 history-container">
          <h5 class="text-center  fw-bold">HISTORY</h5>
          <div class="bg-light w-100  rounded py-3">
            <div class=" history w-100 text-center mt-3">
              <div class="history-data">
                <p>AWS</p><a href="#">VIEW</a>
              </div>
              <div class="history-data">
                <p>SALARIES</p><a href="#">VIEW</a>
              </div>
              <div class="history-data">
                <p>UTILITIES</p><a href="#">VIEW</a>
              </div>
              <div class="history-data">
                <p>MARKETING</p><a href="#">VIEW</a>
              </div>
              <div class="history-data">
                <p>RENT</p><a href="#">VIEW</a>
              </div>
              <div class="history-data">
                <p>EXTRAS</p><a href="#">VIEW</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->

    <div *ngIf="!loader && otpVerified" class="grid-section">
      <div class="d-flex ">
        <div class="mx-2">
          <div class="orderBox text-uppercase ">
            <p class="mb-2">TOTAL PROFIT</p>
            <p class="mb-0 orderBoxNum">{{ expenseData?.totalProfit?.toFixed(0)}} AED</p>
          </div>
        </div>
        <div class="mx-2">
          <div class="orderBox text-uppercase">
            <p class="mb-2">CURRENT MONTH</p>
            <p class="mb-0 orderBoxNum">{{expenseData?.currentMonthProfit?.toFixed(0)}} AED</p>
          </div>
        </div>
        <div class="mx-2">
          <div class="orderBox text-uppercase">
            <p class="mb-2">PREVIOUS MONTH</p>
            <p class="mb-0 orderBoxNum">{{expenseData?.previousMonthProfit?.toFixed(0)}} AED</p>
          </div>
        </div>
        <div class="search-section mx-2 ms-4">
          <div class="">
            <p class="mb-2">SEARCH BY:</p>
          </div>
          <div class=" w-100"><input class="search-input form-control" (input)="onSearchChange()"
              [(ngModel)]="searchText" type="text"></div>
        </div>
        <!-- <div   class="mx-2 position-relative"> -->
        <!-- <div  class="orderBox profit-order-box text-uppercase">
              <p>Profit</p>
              <p class="mb-0 orderBoxNum text-success">{{ (bookingData.totalProfit)| currency:'AED'}}</p>
            </div> -->
        <!-- </div> -->
      </div>
      <div class="generate-bill d-flex justify-content-end">
        <button *ngIf="isFilterApplied" (click)="removeAllFilters()" class="removeBtn me-2">Remove All Filters <i
            class="ms-2 fa-regular fa-circle-xmark"></i></button>
        <button class="excelBtn me-2" (click)="exportToExcel(allMonthlyexpenses,'expense-sheet')">Export Excel <i
            class="ms-2 fa-solid fa-file-excel"></i></button>
        <button class="pdfBtn me-2" (click)="exportToPDF(allMonthlyexpenses,'expense')">Export PDF <i
            class="ms-2 fa-solid fa-file-pdf"></i></button>
        <button class="gradient-btn" (click)="openModal()">Generate Bill</button>
      </div>
      <div class="position-relative">
        <div class="overflow-hide"></div>
        <ng-scrollbar class="">
          <table>
            <thead>
              <tr>
                <!-- <th >Month</th> -->
                <th scope="col" class="" (click)="toggleDatesDropdown('selectedMonth')">
                  {{'MONTH'}}
                  <i class="fa-solid fa-angle-up arrow cursor-pointer" *ngIf="this.isDropdownOpen['selectedMonth']"></i>
                  <i class="fa-solid fa-angle-down arrow cursor-pointer"
                    *ngIf="!this.isDropdownOpen['selectedMonth']"></i>
                  <!-- <div class="dropdown-content" *ngIf="bookedOn">
                    <ul class="text-uppercase text-center">
                      <li (click)="bookmonth('All')">All</li>
                      <li (click)="bookmonth('01')">January</li>
                      <li (click)="bookmonth('02')">February</li>
                      <li (click)="bookmonth('03')">March</li>
                      <li (click)="bookmonth('04')">April</li>
                      <li (click)="bookmonth('05')">May</li>
                      <li (click)="bookmonth('06')">June</li>
                      <li (click)="bookmonth('07')">July</li>
                      <li (click)="bookmonth('08')">August</li>
                      <li (click)="bookmonth('09')">September</li>
                      <li (click)="bookmonth('10')">October</li>
                      <li (click)="bookmonth('11')">November</li>
                      <li (click)="bookmonth('12')">December</li>
                    </ul>
                  </div> -->
                  <!-- Main Dropdown Button -->

                  <!-- Dropdown Content -->
                  <div class="dropdown-content" *ngIf="isDropdownOpen['selectedMonth']">
                    <ul class="text-uppercase text-center">
                      <li (click)="toggleMonth('All', '2025', 'selectedMonth')" class="">
                        <!-- <input type="checkbox"> -->
                        All
                      </li>
                      <li *ngFor="let month of filterMonths"
                        (click)="toggleMonth(month.value,'2025', 'selectedMonth'); $event.stopPropagation()">
                        {{ month.name }}
                        <input type="checkbox" [checked]="isMonthSelected(month.value, '2025', 'selectedMonth')">

                      </li>
                    </ul>
                    <div class="apply-container d-flex justify-content-between">
                      <select (click)="$event.stopPropagation()" [(ngModel)]="selectedDatesYear['selectedMonth']"
                        id="yearSelect">
                        <option value="2024">2024</option>
                        <option value="2025" selected>2025</option> <!-- 'selected' makes 2025 default -->
                        <option value="2026">2026</option>
                      </select>
                      <button class="apply-btn" (click)="applyMonthSelection('selectedMonth')">Apply</button>
                    </div>
                  </div>

                </th>
                <th>BILL ID</th>
                <th>BILL NAME</th>
                <th>BILL TYPE</th>
                <th>AMOUNT</th>
                <!-- <th>PAID</th> -->
                <th scope="col" class="" (click)="toggleDatesDropdown('status')">{{selectedPaymentStatus || 'PAID'}}
                  <i class="fa-solid fa-angle-up arrow cursor-pointer" *ngIf="this.isDropdownOpen['status']"></i>
                  <i class="fa-solid fa-angle-down arrow cursor-pointer" *ngIf="!this.isDropdownOpen['status']"></i>
                  <div class="dropdown-content" *ngIf="isDropdownOpen['status']">
                    <ul class="text-uppercase text-center">
                      <li (click)="filterStatus('All')">All</li>
                      <li (click)="filterStatus('paid')">Yes</li>
                      <li (click)="filterStatus('unpaid')">No</li>
                    </ul>
                  </div>
                </th>
                <th scope="col" class="" (click)="toggleDatesDropdown('selectedPaidMonth')">
                  {{'PAID DATE'}}
                  <i class="fa-solid fa-angle-up arrow cursor-pointer"
                    *ngIf="this.isDropdownOpen['selectedPaidMonth']"></i>
                  <i class="fa-solid fa-angle-down arrow cursor-pointer"
                    *ngIf="!this.isDropdownOpen['selectedPaidMonth']"></i>
                  <!-- <div class="dropdown-content" *ngIf="bookedOn">
                    <ul class="text-uppercase text-center">
                      <li (click)="bookmonth('All')">All</li>
                      <li (click)="bookmonth('01')">January</li>
                      <li (click)="bookmonth('02')">February</li>
                      <li (click)="bookmonth('03')">March</li>
                      <li (click)="bookmonth('04')">April</li>
                      <li (click)="bookmonth('05')">May</li>
                      <li (click)="bookmonth('06')">June</li>
                      <li (click)="bookmonth('07')">July</li>
                      <li (click)="bookmonth('08')">August</li>
                      <li (click)="bookmonth('09')">September</li>
                      <li (click)="bookmonth('10')">October</li>
                      <li (click)="bookmonth('11')">November</li>
                      <li (click)="bookmonth('12')">December</li>
                    </ul>
                  </div> -->
                  <!-- Main Dropdown Button -->

                  <!-- Dropdown Content -->
                  <div class="dropdown-content" [ngStyle]="{right: '10px'}" *ngIf="isDropdownOpen['selectedPaidMonth']">
                    <ul class="text-uppercase text-center">
                      <li (click)="toggleMonth('All', '2025', 'selectedPaidMonth')" class="">
                        <!-- <input type="checkbox"> -->
                        All
                      </li>
                      <li *ngFor="let month of filterMonths"
                        (click)="toggleMonth(month.value,'2025', 'selectedPaidMonth'); $event.stopPropagation()">
                        {{ month?.name }}
                        <input type="checkbox" [checked]="isMonthSelected(month?.value, '2025', 'selectedPaidMonth')">

                      </li>
                    </ul>
                    <div class="apply-container d-flex justify-content-between">
                      <select (click)="$event.stopPropagation()" [(ngModel)]="selectedDatesYear['selectedPaidMonth']"
                        id="yearSelect">
                        <option value="2024">2024</option>
                        <option value="2025" selected>2025</option> <!-- 'selected' makes 2025 default -->
                        <option value="2026">2026</option>
                      </select>
                      <button class="apply-btn" (click)="applyMonthSelection('selectedPaidMonth')">Apply</button>
                    </div>
                  </div>

                </th>
                <th>ACTIONS</th>
                <!-- <th>PAID DATE</th> -->
                <!-- <th>MARKETING</th>
                <th>PAYMENT DUE</th>
                <th>RENT</th>
                <th>PAYMENT DUE</th>
                <th>EXTRAS</th>
                <th>PAYMENT DUE</th>
                <th>PROFIT</th> -->
              </tr>
            </thead>
            <tbody>
              <tr (mouseenter)="hoverIndex = i" (mouseleave)="hoverIndex = -1" (click)="openEditExpense(expense,i)"
                class="my-5" *ngFor="let expense of allMonthlyexpenses; let i = index">
                <td>{{ expense?.month }}</td>
                <td>{{ expense?.billId }}</td>
                <td>{{ expense?.billName }}</td>
                <td>{{ expense?.type }}</td>
                <td>
                  <div class="">
                    <div class="">{{ expense?.amount | number:'1.0-0'}} {{expense?.currency}}</div>
                    <!-- <div *ngIf="expense.categories?.AWS?.type || expense.categories?.AWS?.paymentStatus" class="d-flex payment-status"><span class="recurring">{{expense.categories?.AWS?.type?.replace('_', ' ')}}</span> <div class="mx-1">|</div> <span class="paid" [ngStyle]="{'color': expense.categories?.AWS?.paymentStatus == 'PAID' ? '#1d890b' : '#ec6408'}" >{{expense.categories?.AWS?.paymentStatus}}</span></div> -->
                  </div>
                </td>
                <td>{{ expense?.paymentStatus }}</td>
                <td>{{ expense?.dueDate | date: 'dd/MM/yyyy' }}</td>
                <td (click)="removeExpense(expense.id); $event.stopPropagation()"><i class=" fa-solid fa-trash-can"></i>
                </td>

                <!-- <td><div class="">
                  <div class="">{{ expense.categories?.Salaries?.amount | number:'1.0-0'}} {{expense.categories?.Salaries?.currency}}</div>
                  <div *ngIf="expense.categories?.Salaries?.type || expense.categories?.Salaries?.paymentStatus" class="d-flex payment-status"><span class="recurring">{{expense.categories?.Salaries?.type?.replace('_', ' ')}}</span> <div class="mx-1">|</div> <span class="paid" [ngStyle]="{'color': expense.categories?.Salaries?.paymentStatus == 'PAID' ? '#1d890b' : '#ec6408'}" >{{expense.categories?.Salaries?.paymentStatus}}</span></div>
                </div></td> -->
                <!-- <td>{{ expense.categories?.Salaries?.dueDate | date: 'dd/MM/yyyy' }}</td> -->
                <!-- <td><div class="">
                  <div class="">{{ expense.categories?.Utilities?.amount | number:'1.0-0'}} {{expense.categories?.Utilities?.currency}}</div>
                  <div *ngIf="expense.categories?.Utilities?.type || expense.categories?.Utilities?.paymentStatus" class="d-flex payment-status"><span class="recurring">{{expense.categories?.Utilities?.type?.replace('_', ' ')}}</span> <div class="mx-1">|</div> <span class="paid" [ngStyle]="{'color': expense.categories?.Utilities?.paymentStatus == 'PAID' ? '#1d890b' : '#ec6408'}" >{{expense.categories?.Utilities?.paymentStatus}}</span></div>
                </div></td> -->
                <!-- <td>{{ expense.categories?.Utilities?.dueDate | date: 'dd/MM/yyyy' }}</td>
                <td><div class="">
                  <div class="">{{ expense.categories?.Marketing?.amount | number:'1.0-0'}} {{expense.categories?.Marketing?.currency}}</div>
                  <div *ngIf="expense.categories?.Marketing?.type || expense.categories?.Marketing?.paymentStatus" class="d-flex payment-status"><span class="recurring">{{expense.categories?.Marketing?.type?.replace('_', ' ')}}</span> <div class="mx-1">|</div> <span class="paid" [ngStyle]="{'color': expense.categories?.Marketing?.paymentStatus == 'PAID' ? '#1d890b' : '#ec6408'}" >{{expense.categories?.Marketing?.paymentStatus}}</span></div>
                </div></td>
                <td>{{ expense.categories?.Marketing?.dueDate | date: 'dd/MM/yyyy' }}</td>
                <td><div class="">
                  <div class="">{{ expense.categories?.Rent?.amount | number:'1.0-0'}} {{expense.categories?.Rent?.currency}}</div>
                  <div *ngIf="expense.categories?.Rent?.type || expense.categories?.Rent?.paymentStatus" class="d-flex payment-status"><span class="recurring">{{expense.categories?.Rent?.type?.replace('_', ' ')}}</span> <div class="mx-1">|</div> <span class="paid" [ngStyle]="{'color': expense.categories?.Rent?.paymentStatus == 'PAID' ? '#1d890b' : '#ec6408'}" >{{expense.categories?.Rent?.paymentStatus}}</span></div>
                </div></td> -->
                <!-- <td>{{ expense.categories?.Rent?.dueDate | date: 'dd/MM/yyyy' }}</td> -->
                <!-- <td><div class=""> -->
                <!-- <div class="">{{ expense.categories?.Extras?.totalAmount | number:'1.0-0'}} {{expense.categories?.Extras?.currency}}</div> -->
                <!-- <div *ngIf="expense.categories?.Extras?.type || expense.categories?.Extras?.paymentStatus" class="d-flex payment-status"><span class="recurring">{{expense.categories?.Extras?.type?.replace('_', ' ')}}</span> <div class="mx-1">|</div> <span class="paid" [ngStyle]="{'color': expense.categories?.Extras?.paymentStatus == 'PAID' ? '#1d890b' : '#ec6408'}" [ngStyle]="{'color': expense.categories?.Extras?.paymentStatus == 'PAID' ? '#1d890b' : '#ec6408'}" >{{expense.categories?.Extras?.paymentStatus}}</span></div> -->
                <!-- </div></td> -->
                <!-- <td>{{ expense.categories?.Extras?.dueDate | date: 'dd/MM/yyyy' }}</td> -->
                <!-- <td class="" [ngStyle]="{'color': expense?.profitAmount > 0 ? '#1d890b' : '#ec6408'}" >{{ expense?.profitAmount | number:'1.0-0' }}  {{'AED'}}</td> -->
              </tr>
            </tbody>
          </table>
          <div *ngIf="allMonthlyexpenses.length < 1" class="d-flex h-100 justify-content-center align-items-center"><app-no-result></app-no-result></div>
        </ng-scrollbar>

      </div>
    </div>
    <div *ngIf="!loader && otpVerified" class="pagination-container" [class.pagination-collapsed]="menuCollapsed()">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <span>Go To Page</span>
          <div class="d-flex align-items-center ms-2">
            <form class="d-flex align-items-center" [formGroup]="pageForm">
              <input min="1" max="{{expenseData?.totalPages}}" formControlName="currentPageControl" />
            </form>
            <button class="" (click)="onPageChange(pageForm.value.currentPageControl)"><i
                class="fa-solid fa-arrow-right"></i></button>
          </div>
        </div>
        <ngb-pagination class="m-0" [collectionSize]="expenseData?.totalElements" [(page)]="currentPage" [rotate]="true"
          [boundaryLinks]="true" [pageSize]="itemsPerPage" [maxSize]="maxsize" (pageChange)="onPageChange($event)">
          <ng-template ngbPaginationFirst>First</ng-template>
          <ng-template ngbPaginationPrevious>Prev</ng-template>
          <ng-template ngbPaginationNext>Next</ng-template>
          <ng-template ngbPaginationLast>Last</ng-template>
        </ngb-pagination>
      </div>
    </div>
    } @else if(editExpense && false) {
    <!-- expenses.component.html -->
    <div class="container edit-expense py-4">
      <i class="fa-solid fa-arrow-left-long" (click)="editExpense = false"></i>
      <div class="row g-3">
        <div class="col-md-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body pb-3">
              <h5 class="card-title text-center ">{{ 'AWS' }}</h5>

              <div class="edit-sections mt-0"><strong class="cat-sub-head">Price:</strong>
                <span class="px-2 py-1 bg-light text-dark"><input class="text-center" type="text"
                    [(ngModel)]="editingExpense.categories.AWS.amount"></span>
              </div>

              <div class="edit-sections w-100">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Bill:</strong>
                  <input type="file" accept="image/*" (change)="onFileSelected($event, 'AWS',true)"
                    id="fileInput{{ 'AWS'}}" hidden>

                  <div class="preview-container justify-content-center w-100">
                    <!-- Image preview -->
                    <img (click)="triggerFileInput('AWS',true)" *ngIf="editingExpense.categories.AWS.bill"
                      [src]="editingExpense.categories.AWS.bill" class="img-preview" />

                    <!-- Plus sign upload button -->
                    <button *ngIf="!editingExpense.categories.AWS.bill" type="button" class="btn  "
                      (click)="triggerFileInput('AWS',true)">
                      <span class="plus-sign">+</span>
                    </button>
                  </div>
                </div>

                <!-- <img *ngIf="exp.billUrl" [src]="exp?.billUrl" alt="Bill" width="30" class="ms-2 rounded"> -->
              </div>

              <div class="edit-sections d-flex">
                <strong class="cat-sub-head">Type:</strong> <ng-select [items]="types" bindLabel="display"
                  bindValue="value" [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.AWS.type"></ng-select>
              </div>

              <div class="edit-sections"><strong class="cat-sub-head">Paid:</strong> <ng-select
                  [items]="paymentStatuses"
                  [ngStyle]="{color: editingExpense.categories.AWS.paymentStatus == 'PAID' ? '#a2c030' : 'red'}"
                  [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.AWS.paymentStatus"></ng-select></div>

              <div class="edit-sections" class="d-flex">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Currency:</strong> <ng-select [items]="currency" [searchable]="false"
                    class="edit-ng-select" [clearable]="false"
                    [(ngModel)]="editingExpense.categories.AWS.currency"></ng-select>
                </div>
              </div>
              <div class="card-footer bg-white border-0 text-center pb-0 pt-3">
                <button class="btn save-btn px-4" (click)="save('AWS')">SAVE</button>
              </div>
              <!-- <div *ngIf="exp.extras">
            <div *ngFor="let extra of exp.extras; let i = index" class="d-flex align-items-center mb-2">
              <span class="px-2 py-1 bg-light me-2">{{ extra.label }}</span>
              <span class="px-2 py-1 bg-light me-2">{{ extra.amount }}</span>
              <button class="btn btn-sm btn-outline-danger" (click)="removeExtra(exp, i)">REMOVE</button>
            </div>
            <button class="btn btn-sm btn-outline-success" (click)="addExtra(exp)">ADD</button>
          </div> -->

            </div>

          </div>
        </div>
        <div class="col-md-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body pb-3">
              <h5 class="card-title text-center">{{ 'Marketing' }}</h5>

              <div class="edit-sections mt-0"><strong class="cat-sub-head">Price:</strong>
                <span class="px-2 py-1 bg-light text-dark"><input class="text-center" type="text"
                    [(ngModel)]="editingExpense.categories.Marketing.amount"></span>
              </div>

              <div class="edit-sections w-100">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Bill:</strong>
                  <input type="file" accept="image/*" (change)="onFileSelected($event, 'Marketing',true)"
                    id="fileInput{{ 'Marketing'}}" hidden>

                  <div class="preview-container justify-content-center w-100">
                    <!-- Image preview -->
                    <img (click)="triggerFileInput('Marketing',true)" *ngIf="editingExpense.categories.Marketing.bill"
                      [src]="editingExpense.categories.Marketing.bill" class="img-preview" />

                    <!-- Plus sign upload button -->
                    <button *ngIf="!editingExpense.categories.Marketing.bill" type="button" class="btn  "
                      (click)="triggerFileInput('Marketing',true)">
                      <span class="plus-sign">+</span>
                    </button>
                  </div>
                </div>

                <!-- <img *ngIf="exp.billUrl" [src]="exp?.billUrl" alt="Bill" width="30" class="ms-2 rounded"> -->
              </div>

              <div class="edit-sections d-flex">
                <strong class="cat-sub-head">Type:</strong> <ng-select [items]="types" bindLabel="display"
                  bindValue="value" [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.Marketing.type"></ng-select>
              </div>

              <div class="edit-sections"><strong class="cat-sub-head">Paid:</strong> <ng-select
                  [items]="paymentStatuses"
                  [ngStyle]="{color: editingExpense.categories.Marketing.paymentStatus == 'PAID' ? '#a2c030' : 'red'}"
                  [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.Marketing.paymentStatus"></ng-select></div>

              <div class="edit-sections" class="d-flex">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Currency:</strong> <ng-select [items]="currency" [searchable]="false"
                    class="edit-ng-select" [clearable]="false"
                    [(ngModel)]="editingExpense.categories.Marketing.currency"></ng-select>
                </div>
              </div>
              <div class="card-footer bg-white border-0 text-center pb-0 pt-3">
                <button class="btn save-btn px-4" (click)="save('Marketing')">SAVE</button>
              </div>
              <!-- <div *ngIf="exp.extras">
            <div *ngFor="let extra of exp.extras; let i = index" class="d-flex align-items-center mb-2">
              <span class="px-2 py-1 bg-light me-2">{{ extra.label }}</span>
              <span class="px-2 py-1 bg-light me-2">{{ extra.amount }}</span>
              <button class="btn btn-sm btn-outline-danger" (click)="removeExtra(exp, i)">REMOVE</button>
            </div>
            <button class="btn btn-sm btn-outline-success" (click)="addExtra(exp)">ADD</button>
          </div> -->

            </div>

          </div>
        </div>
        <div class="col-md-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body pb-3">
              <h5 class="card-title text-center">{{ 'Utilities' }}</h5>

              <div class="edit-sections mt-0"><strong class="cat-sub-head">Price:</strong>
                <span class="px-2 py-1 bg-light text-dark"><input class="text-center" type="text"
                    [(ngModel)]="editingExpense.categories.Utilities.amount"></span>
              </div>

              <div class="edit-sections w-100">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Bill:</strong>
                  <input type="file" accept="image/*" (change)="onFileSelected($event, 'Utilities',true)"
                    id="fileInput{{ 'Utilities'}}" hidden>

                  <div class="preview-container justify-content-center w-100">
                    <!-- Image preview -->
                    <img (click)="triggerFileInput('Utilities',true)" *ngIf="editingExpense.categories.Utilities.bill"
                      [src]="editingExpense.categories.Utilities.bill" class="img-preview" />

                    <!-- Plus sign upload button -->
                    <button *ngIf="!editingExpense.categories.Utilities.bill" type="button" class="btn  "
                      (click)="triggerFileInput('Utilities',true)">
                      <span class="plus-sign">+</span>
                    </button>
                  </div>
                </div>

                <!-- <img *ngIf="exp.billUrl" [src]="exp?.billUrl" alt="Bill" width="30" class="ms-2 rounded"> -->
              </div>

              <div class="edit-sections d-flex">
                <strong class="cat-sub-head">Type:</strong> <ng-select [items]="types" bindLabel="display"
                  bindValue="value" [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.Utilities.type"></ng-select>
              </div>

              <div class="edit-sections"><strong class="cat-sub-head">Paid:</strong> <ng-select
                  [items]="paymentStatuses"
                  [ngStyle]="{color: editingExpense.categories.Utilities.paymentStatus == 'PAID' ? '#a2c030' : 'red'}"
                  [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.Utilities.paymentStatus"></ng-select></div>

              <div class="edit-sections" class="d-flex">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Currency:</strong> <ng-select [items]="currency" [searchable]="false"
                    class="edit-ng-select" [clearable]="false"
                    [(ngModel)]="editingExpense.categories.Utilities.currency"></ng-select>
                </div>
              </div>
              <div class="card-footer bg-white border-0 text-center pb-0 pt-3">
                <button class="btn save-btn px-4" (click)="save('Utilities')">SAVE</button>
              </div>
              <!-- <div *ngIf="exp.extras">
            <div *ngFor="let extra of exp.extras; let i = index" class="d-flex align-items-center mb-2">
              <span class="px-2 py-1 bg-light me-2">{{ extra.label }}</span>
              <span class="px-2 py-1 bg-light me-2">{{ extra.amount }}</span>
              <button class="btn btn-sm btn-outline-danger" (click)="removeExtra(exp, i)">REMOVE</button>
            </div>
            <button class="btn btn-sm btn-outline-success" (click)="addExtra(exp)">ADD</button>
          </div> -->

            </div>

          </div>
        </div>
        <div class="col-md-4">
          <div class="card shadow-sm">
            <div class="card-body pb-3">
              <h5 class="card-title text-center ">{{ 'Salaries' }}</h5>

              <div class="edit-sections mt-0"><strong class="cat-sub-head">Price:</strong>
                <span class="px-2 py-1 bg-light text-dark"><input class="text-center" type="text"
                    [(ngModel)]="editingExpense.categories.Salaries.amount"></span>
              </div>

              <div class="edit-sections w-100">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Bill:</strong>
                  <input type="file" accept="image/*" (change)="onFileSelected($event, 'Salaries',true)"
                    id="fileInput{{ 'Salaries'}}" hidden>

                  <div class="preview-container justify-content-center w-100">
                    <!-- Image preview -->
                    <img (click)="triggerFileInput('Salaries',true)" *ngIf="editingExpense.categories.Salaries.bill"
                      [src]="editingExpense.categories.Salaries.bill" class="img-preview" />

                    <!-- Plus sign upload button -->
                    <button *ngIf="!editingExpense.categories.Salaries.bill" type="button" class="btn  "
                      (click)="triggerFileInput('Salaries',true)">
                      <span class="plus-sign">+</span>
                    </button>
                  </div>
                </div>

                <!-- <img *ngIf="exp.billUrl" [src]="exp?.billUrl" alt="Bill" width="30" class="ms-2 rounded"> -->
              </div>

              <div class="edit-sections d-flex">
                <strong class="cat-sub-head">Type:</strong> <ng-select [items]="types" bindLabel="display"
                  bindValue="value" [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.Salaries.type"></ng-select>
              </div>

              <div class="edit-sections"><strong class="cat-sub-head">Paid:</strong> <ng-select
                  [items]="paymentStatuses"
                  [ngStyle]="{color: editingExpense.categories.Salaries.paymentStatus == 'PAID' ? '#a2c030' : 'red'}"
                  [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.Salaries.paymentStatus"></ng-select></div>

              <div class="edit-sections" class="d-flex">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Currency:</strong> <ng-select [items]="currency" [searchable]="false"
                    class="edit-ng-select" [clearable]="false"
                    [(ngModel)]="editingExpense.categories.Salaries.currency"></ng-select>
                </div>
              </div>
              <div class="card-footer bg-white border-0 text-center pb-0 pt-3">
                <button class="btn save-btn px-4" (click)="save('Salaries')">SAVE</button>
              </div>
              <!-- <div *ngIf="exp.extras">
            <div *ngFor="let extra of exp.extras; let i = index" class="d-flex align-items-center mb-2">
              <span class="px-2 py-1 bg-light me-2">{{ extra.label }}</span>
              <span class="px-2 py-1 bg-light me-2">{{ extra.amount }}</span>
              <button class="btn btn-sm btn-outline-danger" (click)="removeExtra(exp, i)">REMOVE</button>
            </div>
            <button class="btn btn-sm btn-outline-success" (click)="addExtra(exp)">ADD</button>
          </div> -->

            </div>

          </div>
        </div>
        <div class="col-md-4">
          <div class="card shadow-sm">
            <div class="card-body pb-3">
              <h5 class="card-title text-center">{{ 'Rent' }}</h5>

              <div class="edit-sections mt-0"><strong class="cat-sub-head">Price:</strong>
                <span class="px-2 py-1 bg-light text-dark"><input class="text-center" type="text"
                    [(ngModel)]="editingExpense.categories.Rent.amount"></span>
              </div>

              <div class="edit-sections w-100">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Bill:</strong>
                  <input type="file" accept="image/*" (change)="onFileSelected($event, 'Rent',true)"
                    id="fileInput{{ 'Rent'}}" hidden>

                  <div class="preview-container justify-content-center w-100">
                    <!-- Image preview -->
                    <img (click)="triggerFileInput('Rent',true)" *ngIf="editingExpense.categories.Rent.bill"
                      [src]="editingExpense.categories.Rent.bill" class="img-preview" />

                    <!-- Plus sign upload button -->
                    <button *ngIf="!editingExpense.categories.Rent.bill" type="button" class="btn  "
                      (click)="triggerFileInput('Rent',true)">
                      <span class="plus-sign">+</span>
                    </button>
                  </div>
                </div>

                <!-- <img *ngIf="exp.billUrl" [src]="exp?.billUrl" alt="Bill" width="30" class="ms-2 rounded"> -->
              </div>

              <div class="edit-sections d-flex">
                <strong class="cat-sub-head">Type:</strong> <ng-select [items]="types" bindLabel="display"
                  bindValue="value" [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.Rent.type"></ng-select>
              </div>

              <div class="edit-sections"><strong class="cat-sub-head">Paid:</strong> <ng-select
                  [items]="paymentStatuses"
                  [ngStyle]="{color: editingExpense.categories.Rent.paymentStatus == 'PAID' ? '#a2c030' : 'red'}"
                  [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.Rent.paymentStatus"></ng-select></div>

              <div class="edit-sections" class="d-flex">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Currency:</strong> <ng-select [items]="currency" [searchable]="false"
                    class="edit-ng-select" [clearable]="false"
                    [(ngModel)]="editingExpense.categories.Rent.currency"></ng-select>
                </div>
              </div>
              <div class="card-footer bg-white border-0 text-center pb-0 pt-3">
                <button class="btn save-btn px-4" (click)="save('Rent')">SAVE</button>
              </div>
              <!-- <div *ngIf="exp.extras">
            <div *ngFor="let extra of exp.extras; let i = index" class="d-flex align-items-center mb-2">
              <span class="px-2 py-1 bg-light me-2">{{ extra.label }}</span>
              <span class="px-2 py-1 bg-light me-2">{{ extra.amount }}</span>
              <button class="btn btn-sm btn-outline-danger" (click)="removeExtra(exp, i)">REMOVE</button>
            </div>
            <button class="btn btn-sm btn-outline-success" (click)="addExtra(exp)">ADD</button>
          </div> -->

            </div>

          </div>
        </div>
        <div class="col-md-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body pb-3">
              <h5 class="card-title text-center">{{ 'Extras' }}</h5>

              <div class="edit-sections mt-0"><strong class="cat-sub-head">Price:</strong>
                <span class="px-2 py-1 bg-light text-dark"><input class="text-center" type="text"
                    [(ngModel)]="editingExpense.categories.AWS.amount"></span>
              </div>

              <div class="edit-sections"><strong class="cat-sub-head">Paid:</strong> <ng-select
                  [items]="paymentStatuses"
                  [ngStyle]="{color: editingExpense.categories.AWS.paymentStatus == 'PAID' ? '#a2c030' : 'red'}"
                  [searchable]="false" class="edit-ng-select" [clearable]="false"
                  [(ngModel)]="editingExpense.categories.AWS.paymentStatus"></ng-select></div>

              <div class="edit-sections" class="d-flex">
                <div class="w-50 d-flex">
                  <strong class="cat-sub-head">Currency:</strong> <ng-select [items]="currency" [searchable]="false"
                    class="edit-ng-select" [clearable]="false"
                    [(ngModel)]="editingExpense.categories.AWS.currency"></ng-select>
                </div>
              </div>

              <div class="edit-extra-forms">
                <form [formGroup]="extrasForm">
                  <div formArrayName="expenses">
                    <div *ngFor="let expense of extras.controls; let i=index" [formGroupName]="i"
                      class=" mb-2 extra-forms-container">
                      <i (click)="removeExtra(i)" class="cross-button fa-solid fa-xmark"></i>
                      <div class="description-input mt-2 expenses-select">
                        <input class="form-control" type="text" formControlName="description" placeholder="Description">
                      </div>
                      <div class="amount-input mt-2 expenses-select">
                        <input class="form-control" type="number" formControlName="amount" placeholder="Enter amount">
                      </div>
                      <div class="payment-input expenses-select">
                        <ng-select [items]="paymentStatuses" [searchable]="false" formControlName="paymentStatus"
                          [clearable]="false" class="edit-ng-select form-control">
                        </ng-select>
                      </div>
                      <div class="currency-input expenses-select">
                        <ng-select [items]="currency" [searchable]="false" formControlName="currency"
                          [clearable]="false" class="edit-ng-select form-control">
                        </ng-select>
                      </div>


                      <div class="due-date-input expenses-select">
                        <input class="form-control" type="date" formControlName="dueDate">
                      </div>
                      <div class="bill-input align-items-center d-flex text-center  expenses-select"
                        [ngClass]="{'bg-white': getBillEditControl(i)?.value}">
                        <input type="file" accept="image/*" (change)="extrasFile($event, i)" id="fileInput{{ i }}"
                          hidden>

                        <div class="preview-container justify-content-center w-100">
                          <img (click)="triggerFileInput(i)" *ngIf="getBillEditControl(i)?.value"
                            [src]="getBillEditControl(i)?.value" class="img-preview" />

                          <button *ngIf="!getBillEditControl(i)?.value" type="button" class="btn  "
                            (click)="triggerFileInput(i)">
                            <span class="plus-sign">Bill</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="d-flex justify-content-between mt-3 mb-2">
                <div class="d-flex justify-content-center ">
                  <button type="button" class="btn gradient-btn" (click)="addExtra()">+ Add</button>
                </div>

                <div class="card-footer bg-white border-0 text-end p-0">
                  <button class="btn save-btn px-4" (click)="save('EXTRAS')">SAVE</button>
                </div>
              </div>
              <div class="d-flex w-100 mt-3 justify-content-center align-items-center">
                <h4 class="fw-bold text-danger mb-0 error-text" *ngIf="this.extrasForm.invalid && extrasForm.touched">
                  Please provide required fields</h4>
              </div>
              <!-- <div *ngIf="exp.extras">
            <div *ngFor="let extra of exp.extras; let i = index" class="d-flex align-items-center mb-2">
              <span class="px-2 py-1 bg-light me-2">{{ extra.label }}</span>
              <span class="px-2 py-1 bg-light me-2">{{ extra.amount }}</span>
              <button class="btn btn-sm btn-outline-danger" (click)="removeExtra(exp, i)">REMOVE</button>
            </div>
            <button class="btn btn-sm btn-outline-success" (click)="addExtra(exp)">ADD</button>
          </div> -->

            </div>

          </div>
        </div>
      </div>
    </div>

    }
  </div>
</div>




<ng-template #generateBillModal>
  <!-- generate-bill.component.html -->
  <div>
    <div>
      <div class="expenses-generate">

        <!-- Modal Header -->
        <div class="modal-header gradient-header">
          <h5 class="modal-title  text-center fw-bold">{{editExpense ? 'Edit' : 'Generate New'}} Bill</h5>
          <button type="button" class="btn-close p-0 ms-0" (click)="dismiss()"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <!-- <table class="input-table">
          <thead>
            <tr>
              <th class="text-center ">MONTH</th>
              <th class="text-center ">EXPENSE CATEGORY</th>
              <th class="text-center ">TYPE</th>
              <th class="text-center ">AMOUNT</th>
              <th class="text-center ">CURRENCY</th>
              <th class="text-center ">BILL</th>
              <th class="text-center ">DESCRIPTION</th>
              <th class="text-center ">DUE DATE</th>
            </tr>
          </thead>
        </table> -->
          <form [formGroup]="billForm" (ngSubmit)="submitData()">
            <div formArrayName="expenses">
              <div *ngFor="let expense of expenses.controls; let i=index" [formGroupName]="i"
                class=" mb-2 gradient-row">
                <div class="bill-head">
                  <h5>BILL DETAILS</h5>
                </div>

                <!-- <i (click)="removeExpense(i)" class="cross-button fa-solid fa-xmark"></i> -->
                <div class=" d-flex expenses-select">
                  <label>BILL NAME</label>
                  <ng-select [items]="categories" formControlName="billName" [addTag]="true" addTagText="Add New Bill:"
                    [clearable]="true" class="custom-ng-select category-input">
                  </ng-select>
                </div>
                <div class=" expenses-select">
                  <label>BILL MONTH</label>
                  <ng-select [items]="months" [searchable]="false" formControlName="month" [clearable]="false"
                    class="custom-ng-select month-input">
                  </ng-select>
                  <ng-select [items]="years" [searchable]="false" formControlName="year" [clearable]="false"
                    class="custom-ng-select month-input ms-3">
                  </ng-select>
                </div>
                <div class="d-flex">
                  <div class=" expenses-select me-4">
                    <label>BILL TYPE</label>
                    <ng-select [items]="types" bindLabel="display" bindValue="value" [searchable]="false"
                      formControlName="type" [clearable]="false" class="custom-ng-select type-input">
                    </ng-select>
                  </div>
                  <div *ngIf="expense.value.type == 'RECURRING'" class="due-date-input expenses-select">
                    <label>PERIOD</label>
                    <!-- <input class="form-control due-date-input" type="date" formControlName="dueDate"> --><ng-select
                      [items]="periods" [searchable]="false" formControlName="period" bindLabel="label"
                      bindValue="value" [clearable]="false" class="custom-ng-select currency-input me-3">
                    </ng-select>

                    <!-- <input type="text"
             placeholder="Daterangepicker"
             class="form-control"
             bsDaterangepicker> -->

                  </div>
                </div>
                <div class=" expenses-select">
                  <label>ENTER AMOUNT</label>
                  <input class="form-control amount-input me-3" type="text" (keypress)="onlyNumbers($event)"
                    formControlName="amount" placeholder="Enter amount">
                  <ng-select [items]="currency" [searchable]="false" formControlName="currency" [clearable]="false"
                    class="custom-ng-select currency-input">
                  </ng-select>
                </div>
                <div class=" expenses-select">
                  <label>BILL PAID</label>
                  <ng-select [items]="paymentStatuses" [searchable]="false" formControlName="paymentStatus"
                    [clearable]="false" class="custom-ng-select currency-input me-3">
                  </ng-select>
                  <input *ngIf="expense.value.paymentStatus == 'PAID'" class="form-control due-date-input" type="date"
                    formControlName="dueDate">
                </div>
                <!-- <div class="bill-input expenses-select">
                <input class="form-control" type="file" formControlName="bill">
              </div> -->
                <div class=" expenses-select">
                  <label>BILL INVOICE</label>
                  <input type="file" accept="image/*" (change)="onFileSelected($event, i)" id="fileInput{{ i }}"
                    class="bill-input" hidden>

                  <div class="preview-container justify-content-center w-100">
                    <!-- Image preview -->
                    <img (click)="triggerFileInput(i)" *ngIf="getBillControl(i).value" [src]="getBillControl(i).value"
                      class="img-preview" />

                    <!-- Plus sign upload button -->
                    <button *ngIf="!getBillControl(i).value" type="button" class="btn  " (click)="triggerFileInput(i)">
                      <span class="plus-sign">+</span>
                    </button>
                  </div>
                </div>
                <div class=" expenses-select">
                  <label>DESCRIPTION</label>
                  <input class="form-control description-input" type="text" formControlName="description"
                    placeholder="Description">
                </div>

              </div>
            </div>

            <div class="d-flex justify-content-between mt-3">
              <div class="">
                <h4 class="fw-bold text-danger error-text" *ngIf="this.billForm.invalid && billForm.touched">Please
                  provide required fields</h4>
              </div>
              <!-- <button type="button" class="btn gradient-btn" (click)="addExpense()">+ Another Expense</button> -->
              <button type="submit" class="btn btn-outline-primary">{{editExpense ? 'Save' : 'Add'}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</ng-template>